import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from '../../helpers/helpers'

import './WeeklySummary.css'

const summarizetimeSheet = (date, timeSheet) => {
  const year = date.format('YYYY')
  const month = date.format('MMMM')

  if(!timeSheet) return 0
  if(!timeSheet[year][month]) return 0

  return Object.keys(timeSheet[year][month]).reduce(function(sum, key) {
    return sum + parseFloat(timeSheet[year][month][key])
  }, 0)
}

const WeeklySummary = ({ date, timeSheet }) => {
  const totalHours = summarizetimeSheet(date, timeSheet)
  return (
    <div className='weekly-summary'>
      {totalHours} hours ({formatPrice(totalHours * 835)})
    </div>
  )
}

WeeklySummary.propTypes = {
  date: PropTypes.object.isRequired,
  timeSheet: PropTypes.object.isRequired
}

export default WeeklySummary



// WEBPACK FOOTER //
// ./src/components/WeeklySummary/WeeklySummary.js